import {
  f,
  i,
  u
} from "./anacapri-chunk.TOMZZDRF.js";

// node_modules/@lit/reactive-element/decorators/property.js
var o = { attribute: true, type: String, converter: u, reflect: false, hasChanged: f };
var r = (t = o, e4, r4) => {
  const { kind: n2, metadata: i2 } = r4;
  let s = globalThis.litPropertyMetadata.get(i2);
  if (void 0 === s && globalThis.litPropertyMetadata.set(i2, s = /* @__PURE__ */ new Map()), s.set(r4.name, t), "accessor" === n2) {
    const { name: o3 } = r4;
    return { set(r5) {
      const n3 = e4.get.call(this);
      e4.set.call(this, r5), this.requestUpdate(o3, n3, t);
    }, init(e5) {
      return void 0 !== e5 && this.P(o3, void 0, t), e5;
    } };
  }
  if ("setter" === n2) {
    const { name: o3 } = r4;
    return function(r5) {
      const n3 = this[o3];
      e4.call(this, r5), this.requestUpdate(o3, n3, t);
    };
  }
  throw Error("Unsupported decorator location: " + n2);
};
function n(t) {
  return (e4, o3) => "object" == typeof o3 ? r(t, e4, o3) : ((t2, e5, o4) => {
    const r4 = e5.hasOwnProperty(o4);
    return e5.constructor.createProperty(o4, r4 ? { ...t2, wrapped: true } : t2), r4 ? Object.getOwnPropertyDescriptor(e5, o4) : void 0;
  })(t, e4, o3);
}

// node_modules/@lit/reactive-element/decorators/state.js
function r2(r4) {
  return n({ ...r4, state: true, attribute: false });
}

// node_modules/@lit/reactive-element/decorators/base.js
var e = (e4, t, c) => (c.configurable = true, c.enumerable = true, Reflect.decorate && "object" != typeof t && Object.defineProperty(e4, t, c), c);

// node_modules/@lit/reactive-element/decorators/query.js
function e2(e4, r4) {
  return (n2, s, i2) => {
    const o3 = (t) => t.renderRoot?.querySelector(e4) ?? null;
    if (r4) {
      const { get: e5, set: r5 } = "object" == typeof s ? n2 : i2 ?? (() => {
        const t = Symbol();
        return { get() {
          return this[t];
        }, set(e6) {
          this[t] = e6;
        } };
      })();
      return e(n2, s, { get() {
        let t = e5.call(this);
        return void 0 === t && (t = o3(this), (null !== t || this.hasUpdated) && r5.call(this, t)), t;
      } });
    }
    return e(n2, s, { get() {
      return o3(this);
    } });
  };
}

// node_modules/@lit/reactive-element/decorators/query-all.js
var e3;
function r3(r4) {
  return (n2, o3) => e(n2, o3, { get() {
    return (this.renderRoot ?? (e3 ?? (e3 = document.createDocumentFragment()))).querySelectorAll(r4);
  } });
}

// node_modules/@lit/reactive-element/decorators/query-assigned-elements.js
function o2(o3) {
  return (e4, n2) => {
    const { slot: r4, selector: s } = o3 ?? {}, c = "slot" + (r4 ? `[name=${r4}]` : ":not([name])");
    return e(e4, n2, { get() {
      const t = this.renderRoot?.querySelector(c), e5 = t?.assignedElements(o3) ?? [];
      return void 0 === s ? e5 : e5.filter((t2) => t2.matches(s));
    } });
  };
}

// src/styles/base.css
var styles = i`:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  position: relative;
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
`;
var base_default = styles;

// src/styles/feedback.css
var styles2 = i`ul.ana-feedback {
  padding: 0;
  margin: 0;
  font-style: normal;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.ana-content-prefiller .ana-feedback slot::slotted(li:first-of-type) {
  margin: 0.5rem 0 0;
}

.ana-tile .ana-feedback slot::slotted(li:first-of-type) {
  margin: 2rem 0 0;
}

.ana-feedback slot[name='error']::slotted(li),
.ana-feedback slot[name='warning']::slotted(li),
.ana-error,
.ana-warning {
  color: #fff;
  border-radius: 6px;
  padding: 0.5rem;
  line-height: 1rem;
  width: fit-content;
}

.ana-feedback slot[name='error']::slotted(li),
.ana-error {
  background: var(--ao-color-red);
}

.ana-feedback slot[name='error']::slotted(li)::before,
.ana-error::before {
  content: '\\f06a';
  font-family: 'FontAwesome';
  margin-right: 0.5rem;
}

.ana-feedback slot[name='warning']::slotted(li),
.ana-warning {
  background: var(--ao-color-orange);
}

.ana-feedback slot[name='warning']::slotted(li)::before,
.ana-warning::before {
  content: '\\f071';
  font-family: 'FontAwesome';
  margin-right: 0.5rem;
}
`;
var feedback_default = styles2;

// src/styles/input.css
var styles3 = i`input {
  --ana-input-color-border: var(--ao-color-ash);
  box-sizing: inherit;
  font: inherit;
  display: inline-block;
  font-size: 1rem;
  padding: 0.3125rem 0.5rem 0.375rem;
  border: 1px solid var(--ana-input-color-border);
  border-radius: 6px;
  margin-right: 0.5rem;
  color: var(--ao-color-charcoal);
  margin-bottom: var(--ao-space-vertical, 1rem);
  transition: var(--ana-transition-focus);
}

input.error {
  --ana-input-color-border: var(--ao-color-red);
  box-shadow: inset 0 0 0 1px var(--ana-input-color-border);
  background: var(--ao-color-red-faded);
}

input.warning {
  --ana-input-color-border: var(--ao-color-orange);
  box-shadow: inset 0 0 0 1px var(--ana-input-color-border);
  background: var(--ao-color-orange-faded);
}

input:focus:not(.error):not(.warning) {
  --ana-input-color-border: var(--ao-color-attention);
}

input:focus {
  outline: 0;
  box-shadow:
    inset 0 0 0 1px var(--ana-input-color-border),
    0 0 0 4px var(--ao-color-blue);
}

.clear-button {
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
}
.clear-button:hover {
  background: var(--ao-color-smoke);
}
`;
var input_default = styles3;

// src/styles/token.css
var styles4 = i`:host,
::backdrop {
  --ao-font-default: 'Aspira', arial, sans-serif;
  --ao-font-heading: 'Aspira', 'Century Gothic', CenturyGothic, AppleGothic, verdana, sans-serif;

  --ao-shadow-s: 0 4px 4px rgba(0, 0, 0, 0.1);
  --ao-shadow-m: 0px 4px 16px var(--ao-color-blue-dark);
  --ao-shadow-l: 0px 8px 32px var(--ao-color-blue-dark);

  --ao-border-radius-s: 4px;
  --ao-border-radius-m: 8px;
  --ao-border-radius-l: 32px;

  --ao-space-s: 0.5rem;
  --ao-space-m: 1rem;
  --ao-space-l: 2rem;

  --ao-height-xs: 2rem;
  --ao-height-s: 2.5rem;
  --ao-height-m: 3rem;
  --ao-height-l: 4rem;

  --ao-width-xs: 96px;
  --ao-width-s: 128px;
  --ao-width-m: 192px;
  --ao-width-l: 256px;
  --ao-width-xl: 384px;
  --ao-width-xxl: 512px;
  --ao-width-xxxl: 768px;
  --ao-width-max: 1200px;
  --ao-width-full: 100%;

  --ao-z-index-button-prefiller: 0;
  --ao-z-index-button: 1;
  --ao-z-index-button-feedback: 2;
  --ao-z-index-hover: 3;
  --ao-z-index-focus: 4;

  --ao-color-blue-dark: #06274a;
  --ao-color-blue: #00426a;
  --ao-color-steel-dark: #1c7099;
  --ao-color-steel: #207daa;
  --ao-color-attention-dark: #3d9ed0;
  --ao-color-attention: #41b6e6;
  --ao-color-attention-light: #a4dcf7;
  --ao-color-sky: #c8e9fc;
  --ao-color-sky-light: #e4f4fe;
  --ao-color-cobalt: #06c;
  --ao-color-cobalt-faded: #def;
  --ao-color-green: #070;
  --ao-color-green-faded: #efe;
  --ao-color-orange: #d64000;
  --ao-color-orange-faded: #fed;
  --ao-color-red: #d1002a;
  --ao-color-red-faded: #fee;
  --ao-color-charcoal: #444;
  --ao-color-graphite: #666;
  --ao-color-ash: #949494;
  --ao-color-smoke: #dcdcdc;
  --ao-color-fog: #f4f4f4;
  --ao-color-white: white;
  --ao-color-transparent: transparent;
  --ao-gradient-blue: linear-gradient(#00426a, #06274a);
  --ao-gradient-fog: linear-gradient(#f4f4f4, #dcdcdc);
  --ao-color-text-primary: #444;
  --ao-color-text-secondary: #666;

  --ana-transition-focus: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease,
    border 0.2s ease;
}

@media (prefers-reduced-motion) {
  :host {
    --ana-transition-focus: none;
  }
}
`;
var token_default = styles4;

// src/styles/typography.css
var styles5 = i`.heading-100,
.heading-200,
.heading-300,
.heading-400,
.heading-500,
.heading-600 {
  --ana-font-size: 2rem;
  --ana-line-height: 2rem;
  --ana-font-weight: 700;

  font-family: var(--ao-font-heading);
  font-size: var(--ana-font-size);
  font-weight: var(--ana-font-weight);
  line-height: var(--ana-line-height);
  color: var(--ana-color, var(--ao-color-charcoal));

  margin: 0;
}

.heading-100 {
  --ana-color: var(--ao-color-blue);
  --ana-line-height: 2.5rem;
}

.heading-200 {
  --ana-font-size: 1.75rem;
}

.heading-300 {
  --ana-font-size: 1.5rem;
  --ana-font-weight: normal;
}

.heading-400 {
  --ana-font-size: 1.25rem;
  --ana-line-height: 1.5rem;
}

.heading-500 {
  --ana-font-size: 1.125rem;
  --ana-font-weight: normal;
  --ana-line-height: 1.5rem;
}

.heading-600 {
  --ana-font-size: 1rem;
  --ana-line-height: 1.5rem;
}

.small {
  font-size: 0.75rem;
}

.italic {
  font-style: italic;
}

.bold {
  font-weight: 700;
}
`;
var typography_default = styles5;

export {
  n,
  r2 as r,
  e2 as e,
  r3 as r2,
  o2 as o,
  base_default,
  feedback_default,
  input_default,
  token_default,
  typography_default
};
/*! Bundled license information:

@lit/reactive-element/decorators/property.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/state.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/base.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-all.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-elements.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/custom-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/event-options.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-async.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-nodes.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
